import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="dinestack-footer">
            <div className="dinestack-footer-content">
                <p>Powered by <strong>Vyanjan</strong></p>
                <p className="copyright">&copy; {new Date().getFullYear()} Vyanjan. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
